import React from "react";
import "./Contact.css";
import { personalInfo } from "../data/portfolioData";
import { HiMail, HiLocationMarker, HiExternalLink } from "react-icons/hi";
import { FaLinkedin, FaGithub } from "react-icons/fa";

function Contact() {
  const contactCards = [
    {
      title: "Email",
      value: personalInfo.links.email,
      href: `mailto:${personalInfo.links.email}`,
      icon: <HiMail size={24} />,
      label: "Send an email",
    },
    {
      title: "LinkedIn",
      value: "linkedin.com/in/prasannakumarhm",
      href: personalInfo.links.linkedin,
      icon: <FaLinkedin size={24} />,
      label: "Connect on LinkedIn",
      isExternal: true,
    },
    {
      title: "GitHub",
      value: "github.com/prasanna34567u78",
      href: personalInfo.links.github,
      icon: <FaGithub size={24} />,
      label: "Explore repositories",
      isExternal: true,
    },
    {
      title: "Location",
      value: personalInfo.location,
      href: null,
      icon: <HiLocationMarker size={24} />,
      label: "Current Base",
    },
  ];

  return (
    <section id="contact" className="contact-section section">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">Get In Touch</span>
          <h2 className="section-title">Contact</h2>
          <p className="section-subtitle">
            Open to discussing backend engineering roles, distributed systems, and observability challenges.
          </p>
        </div>

        <div className="contact-cards-grid">
          {contactCards.map((card, index) => {
            if (card.href) {
              return (
                <a
                  key={index}
                  href={card.href}
                  target={card.isExternal ? "_blank" : undefined}
                  rel={card.isExternal ? "noopener noreferrer" : undefined}
                  className="contact-card"
                  aria-label={card.label}
                >
                  <div className="contact-icon-box">{card.icon}</div>
                  <div className="contact-card-info">
                    <span className="contact-card-title">{card.title}</span>
                    <span className="contact-card-value">{card.value}</span>
                  </div>
                  {card.isExternal && <HiExternalLink size={16} className="contact-card-ext" />}
                </a>
              );
            }

            return (
              <div key={index} className="contact-card static-card">
                <div className="contact-icon-box">{card.icon}</div>
                <div className="contact-card-info">
                  <span className="contact-card-title">{card.title}</span>
                  <span className="contact-card-value">{card.value}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Contact;
